import { Box, styled } from "@mui/system";
import { FC } from "react";
import { NavLink } from "react-router-dom";
import { H1, Paragraph } from "../Typography";

const StyledBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "baseline",
  margin: "0 0 1.5rem 0",
  padding: "0 0 1.25rem 0",
  borderBottom:
    theme.palette.mode === "light"
      ? `1px solid ${theme.palette.grey[400]}`
      : `1px solid ${theme.palette.background.paper}`,
  "& p": {
    padding: "0px 10px",
  },
}));

interface Prop {
  name: string;
  subName: string;
  path: string;
}
const Breadcrumb: FC<Prop> = (props) => {
  const { name, subName, path } = props;
  return (
    <StyledBox>
      <H1 fontSize="1.5rem" lineHeight="1">
        {subName}
      </H1>
      <Paragraph sx={{ borderRight: "1px solid", lineHeight: "15px" }}>
        <NavLink to={`${path}`}>{name}</NavLink>
      </Paragraph>
      <Paragraph>{subName}</Paragraph>
    </StyledBox>
  );
};

export default Breadcrumb;
